var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "TwoDimensionalCode.Create",
    "options": {
        "objc_class_prefix": "TwoDimensionalCodeCreate",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Response",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "randomCode",
                    "id": 1
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/component/qrcode-login/codecreate.pb.js